import { render, staticRenderFns } from "./reimbursement-detail.vue?vue&type=template&id=318fa550&"
import script from "./reimbursement-detail.vue?vue&type=script&lang=js&"
export * from "./reimbursement-detail.vue?vue&type=script&lang=js&"
import style0 from "./reimbursement-detail.vue?vue&type=style&index=0&id=318fa550&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports